import { memo, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { LotDetailContext } from "../../../Contexts/LotDetailContext";
import DataTable from "../../../DataTable/datatable.component";

interface BatchesSectionProps {
    showClassifications?: boolean,
}

const BatchesSection = memo(function BatchesSection({ showClassifications = true }: BatchesSectionProps) {
    const { t } = useTranslation();
    const {
        lotDetail: {
            batches
        }
    } = useContext(LotDetailContext);

    const tableColumns = [
        {
            Header: t('LotDetails.Batches.BatchNumber'),
            accessor: 'batchNumber'
        },
        {
            Header: t('LotDetails.Batches.Grade'),
            accessor: 'grade'
        },
        {
            Header: t('LotDetails.Batches.Status'),
            accessor: 'status'
        },
        {
            Header: t('LotDetails.Batches.TotalWeight'),
            accessor: 'totalWeight'
        },
        {
            Header: t('LotDetails.Batches.WeightUsed'),
            accessor: 'weightUsed'
        },
        {
            Header: t('LotDetails.Batches.SystemClassification'),
            accessor: 'systemClassification'
        },
        {
            Header: t('LotDetails.Batches.OperatorClassification'),
            accessor: 'operatorClassification'
        }
    ];

    const initialState = {
        sortBy: [
            {
                id: 'batchStartUtc',
                desc: false
            }
        ],
        hiddenColumns: !showClassifications ? ["systemClassification", "operatorClassification"] : []
    };

    return batches?.length > 0
        ? <DataTable tableColumns={tableColumns} tableData={batches} initialState={initialState} showPaging={false} />
        : <span>{t('CommonResponses.NoData')}</span>;
});

export default BatchesSection;